import { render, staticRenderFns } from "./kanban-card.vue?vue&type=template&id=592150e6&scoped=true"
import script from "./kanban-card.vue?vue&type=script&lang=js"
export * from "./kanban-card.vue?vue&type=script&lang=js"
import style0 from "./kanban-card.vue?vue&type=style&index=0&id=592150e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592150e6",
  null
  
)

export default component.exports